export default "__VITE_ASSET__D7wixR3C__"